module.exports = __webpack_public_path__ + "img/avatar3.ba0b4d8d.jpg";